import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { setStory } from "../../../../controller/reducer/stories";


function StoryCard({ dispatch, story }) {
  return (
    <Card
      border="info"
      className="m-4"
      style={{ minWidth: "15rem", maxWidth: "18rem" }}
    >
      <Card.Img variant="top" src={story.image} />
      <Card.Body
        as={Link}
        to={"/story/" + story._id}
        onClick={() => dispatch(setStory(story._id))}
      >
        <Card.Title className="text-center h5 font-weight-normal text-truncate">
          {story.name}
        </Card.Title>
        <Card.Text className="text-muted">
          {story.desc} shares {story.gender === "M" ? "his" : "her"} Covid
          Recovery Story
        </Card.Text>
      </Card.Body>
      <Card.Footer className="text-muted">Posted: {story.created}</Card.Footer>
    </Card>
  );
}

export default StoryCard;
